<div class="snippet-container">
	<ng-container *ngIf="!editMode">
		<div [ngClass]="[snippet.paddingH, snippet.paddingV, snippet.backgroundColour]" [innerHTML]="snippet.content"></div>
		<div class="text-end mt-2">
			<button class="btn btn-sm btn-danger ms-2" (click)="deleteConfirm()">Remove</button>
			<button class="btn btn-sm btn-primary ms-2" (click)="editSnippet()">Edit</button>
		</div>
	</ng-container>

	<ng-container *ngIf="editMode">
		<div class="m-3">
			<input type="text" class="form-control" [(ngModel)]="snippet.content" />

		</div>
		<div class="text-end mt-2">
			<button class="btn btn-sm btn-primary" (click)="cancel()">Cancel</button>
			<button class="btn btn-sm btn-primary ms-2" (click)="save()">Save</button>
		</div>
	</ng-container>

</div>

<app-confirmation *ngIf="this.confirmationData.open" (complete)="confirmAction($event)" [data]="confirmationData"></app-confirmation>
<app-snippet-edit [snippet]="snippet" (modalAction)="editModalAction($event)" *ngIf="snippetEditModal"></app-snippet-edit>

